import {AfterViewInit, Component, OnInit} from '@angular/core';
import {environment} from '../environments/environment';
import {ClientAuthService} from '@proleis/proleis-web-app';

@Component({
  selector: 'pls-home',
  templateUrl: 'home.view.component.html',
  styleUrls: ['home.view.component.scss']
})
export class HomeViewComponent implements OnInit, AfterViewInit {

  environment: any;

  constructor(public clientAuth: ClientAuthService) {
  }

  ngOnInit() {
    this.environment = environment;
    this.clientAuth.validateAuth();
  }

  ngAfterViewInit() {

  }

  logout() {
    this.clientAuth.logout();
  }


}
